import { createAction, props } from '@ngrx/store';
import { LeadSourceTag } from '@shared/models/lead-source-tag';

export const createLeadSourceTag = createAction(
  '[Lead Source Tags] Create Lead Source Tag',
  props<{ leadSourceTag: Partial<LeadSourceTag> }>(),
);

export const createLeadSourceTagSuccess = createAction(
  '[Lead Source Tags] Create Lead Source Tag Success',
  props<{ leadSourceTag: LeadSourceTag }>(),
);

export const createLeadSourceTagFailure = createAction(
  '[Lead Source Tags] Create Lead Source Tag Failure',
  props<{ error: any }>(),
);
